import { createSlice } from "@reduxjs/toolkit";
const adminToogle = createSlice({
    name: 'adminToogleAction',
    initialState: {
        adminToogleAction:true,
        transitionTime: 0
    },
    reducers: {
        setAdminToogle : (state,action) => { 
            state.adminToogleAction = action.payload.adminToogleAction
            state.transitionTime = action.payload.transitionTime;
        }
        
    }
});
export const  addAdminToogle  = adminToogle.actions.setAdminToogle;
export default adminToogle.reducer;